import { getApplicationServerKey, saveWebToken, getUserApplicationServerKey, saveUserWebToken } from "../APIs";

export const register = async () => {
  if ("serviceWorker" in navigator) {
    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) await navigator.serviceWorker.register(process.env.PUBLIC_URL + "/sw.js");
  } else {
    console.warn("Service Workers are not Supported!");
  }
};

export const unregister = async () => {
  if ("serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) await registration.unregister();
  }
};

const _subscribe = async (getServerKey, saveToken) => {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service Workers are not Supported!");
    return;
  }

  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration) return;

  let subscription = await registration.pushManager.getSubscription();

  if (subscription === null) {
    const serverKey = await getServerKey();

    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: serverKey,
    });

    if (subscription) await saveToken(subscription);
  }
};

export const subscribe = () => _subscribe(getApplicationServerKey, (subscription) => saveWebToken({ webTkn: subscription }));

export const subscribeAsUser = () => _subscribe(getUserApplicationServerKey, (subscription) => saveUserWebToken(JSON.stringify(subscription)));
